<template>
    <div v-route-title="'项目库'">
        <div class="database-view">
            <div class="header-view pr">
                <span class="huishouzhan_title">项目库</span>
                <div class="btn-layer">
                    <el-button @click="addRow" type="primary" icon="el-icon-circle-plus-outline">添加项目</el-button>
                </div>
            </div>
            <el-form class="yq-search-form" inline :model="searchModel">
                <el-form-item>
                    <el-input v-model="searchModel.id" type="number" style="width: 90px;" placeholder="项目ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchModel.nameLike" style="width: 120px;" placeholder="项目名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="searchModel.disabled" placeholder="是否停用" clearable style="width: 120px;">
                        <el-option :value="false" label="启用"></el-option>
                        <el-option :value="true" label="停用"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="过期时间">
                    <date-picker v-model="searchModel.expiredAtGe" style="width: 140px;"></date-picker>
                    至
                    <date-picker v-model="searchModel.expiredAtLe" style="width: 140px;"></date-picker>
                </el-form-item>
                <el-form-item>
                   <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <div v-if="data">
                <el-table class="yq-table" :data="data.content" style="width: 100%">
                    <el-table-column
                            label="序号"
                            type="index"
                            :index="indexMethod" width="60">
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            label="ID" width="60">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="项目名称">
                    </el-table-column>
                    <el-table-column
                            prop="disabled"
                            label="停用" width="60">
                        <boolean-value slot-scope="scope" :value="scope.row.disabled"></boolean-value>
                    </el-table-column>
                    <el-table-column
                            label="过期时间" width="120">
                        <pretty-date-time slot-scope="scope" :value="scope.row.expiredAt" format="YYYY-MM-DD"/>
                    </el-table-column>
                    <el-table-column
                            label="初始管理用户" width="120">
                        <span slot-scope="scope">{{scope.row.adminUser?scope.row.adminUser.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="创建时间" width="180">
                        <pretty-date-time slot-scope="scope" :value="scope.row.createdAt"/>
                    </el-table-column>
                    <el-table-column
                            label="创建用户" width="120">
                        <span slot-scope="scope">{{scope.row.creatorUser?scope.row.creatorUser.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="修改时间" width="180">
                        <pretty-date-time slot-scope="scope" :value="scope.row.editedAt"/>
                    </el-table-column>
                    <el-table-column
                            label="修改用户" width="120">
                        <span slot-scope="scope">{{scope.row.editorUser?scope.row.editorUser.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="操作" width="120">
                        <template slot-scope="scope">
                            <el-link icon="el-icon-edit" @click="editRow(scope.row)">修改</el-link>
                            <el-link icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="clear"></div>
        <div class="magin10"></div>
        <div class="foot" v-if="data">
            <el-pagination
                    layout="prev, pager, next" background
                    :total="data.totalElements" :current-page="data.number+1"
                    @current-change="fetchData($event)">
            </el-pagination>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改项目':'添加项目'" :visible.sync="dialogFormVisible">
            <el-form ref="form" :model="model" label-width="120px" :rules="rules" size="mini">
                <el-form-item label="项目名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="是否停用" prop="disabled">
                    <el-select v-model="model.disabled">
                        <el-option :value="false" label="否"></el-option>
                        <el-option :value="true" label="是"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="过期时间" prop="expiredAt">
                    <date-picker v-model="model.expiredAt"></date-picker>
                </el-form-item>
                <el-form-item label="可用页面类型" prop="pageTypeAssignments">
                    <el-select v-model="model.pageTypeAssignments" value-key="pageType" multiple>
                        <el-option v-for="item in pageTypes" :key="item.type" :label="item.typeName" :value="{pageType:item.type}"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="可用栏目类型" prop="sectionTypeAssignments">
                    <el-select v-model="model.sectionTypeAssignments" value-key="sectionType" multiple>
                        <el-option v-for="item in sectionTypes" :key="item.type" :label="item.typeName" :value="{sectionType:item.type}"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="可用模板" prop="templateAssignments">
                    <template-select :value="assignedTemplates" @input="onAssignedTemplatesInput" multiple></template-select>
                </el-form-item>
            </el-form>
            <el-form ref="adminUserForm" :model="model.adminUser" label-width="120px" :rules="adminUserRules"
                     v-if="!model.id" size="mini">
                <el-form-item label="管理用户名称" prop="name">
                    <el-input v-model="model.adminUser.name"></el-input>
                </el-form-item>
                <el-form-item label="管理用户昵称" prop="nickName">
                    <el-input v-model="model.adminUser.nickName"></el-input>
                </el-form-item>
                <el-form-item label="管理用户密码" prop="pwd">
                    <el-input v-model="model.adminUser.pwd" type="password"></el-input>
                </el-form-item>
                <el-form-item label="管理用户确认密码" prop="pwd2">
                    <el-input v-model="model.adminUser.pwd2" type="password"></el-input>
                </el-form-item>
            </el-form>
            <div>
                <el-button @click="addDatasource" size="mini">添加数据源</el-button>
            </div>
            <el-form v-for="(datasourceAssignment,index) in model.datasourceAssignments" :key="index" inline
                     ref="datasourceForm" :model="datasourceAssignment" label-width="120px" :rules="datasourceRules"
                     size="mini">
                <el-form-item label="数据源" prop="datasourceConfig">
                    <datasource-select v-model="datasourceAssignment.datasourceConfig"></datasource-select>
                </el-form-item>
                <el-form-item label="可编辑" prop="editable">
                    <el-select v-model="datasourceAssignment.editable">
                        <el-option :value="true" label="是"></el-option>
                        <el-option :value="false" label="否"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="deleteDatasource(index)">删除数据源</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import projectService from '../service/project'
    import DatasourceSelect from '../components/common/DatasourceSelect'
    import TemplateSelect from '../components/common/TemplateSelect'
    import pageTypeService from '../service/page-type'
    import sectionTypeService from '../service/section-type'

    export default {
        name: "ProjectAdmin",
        components: {DatasourceSelect, TemplateSelect},
        data() {
            const checkName = (rule, value, callback) => {
                if (value) {
                    projectService.checkProjectName(value).then(response => {
                        if (response.data && this.model.id !== response.data.id) {
                            callback(new Error('该项目已存在'));
                        } else {
                            callback();
                        }
                    }).catch(() => {
                        callback(new Error('校验出错'));
                    })
                } else {
                    callback();
                }
            }
            const checkAdminUserName = (rule, value, callback) => {
                if (value) {
                    projectService.checkProjectAdminName(value).then(response => {
                        if (response.data) {
                            callback(new Error('该用户已存在'));
                        } else {
                            callback();
                        }
                    }).catch(() => {
                        callback(new Error('校验出错'));
                    })
                } else {
                    callback();
                }
            }
            const checkPwd2 = (rule, value, callback) => {
                if (value && this.model.adminUser.pwd && value !== this.model.adminUser.pwd) {
                    callback(new Error('密码不一致'));
                } else {
                    callback();
                }
            }
            const checkDatasourceConfig = (rule, value, callback) => {
                if (value) {
                    for(const item of this.model.datasourceAssignments){
                        if(item.datasourceConfig && item.datasourceConfig !== value &&
                            item.datasourceConfig.id === value.id){
                            callback(new Error('该数据源已存在'));
                            return
                        }
                    }
                    callback();
                } else {
                    callback();
                }
            }
            return {
                data: null,
                dialogFormVisible: false,
                searchModel: {
                    id: null,
                    nameLike: null,
                    disabled: null,
                    expiredAtGe: null,
                    expiredAtLe: null
                },
                searchParams: {
                    id: null,
                    nameLike: null,
                    disabled: null,
                    expiredAtGe: null,
                    expiredAtLe: null
                },
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入项目名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                        {validator: checkName, trigger: 'blur'}
                    ]
                },
                adminUserRules: {
                    name: [
                        {required: true, message: '请输入管理用户名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                        {validator: checkAdminUserName, trigger: 'blur'}
                    ],
                    nickName: [
                        {required: true, message: '请输入管理用户昵称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '请输入管理用户密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    pwd2: [
                        {required: true, message: '请输入管理用户确认密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                        {validator: checkPwd2, trigger: 'blur'}
                    ],
                },
                datasourceRules: {
                    datasourceConfig: [
                        {required: true, message: '请选择数据源', trigger: 'blur'},
                        {validator: checkDatasourceConfig, trigger: 'blur'}
                    ],
                    editable: [
                        {required: true, message: '请选择是否可编辑数据', trigger: 'blur'},
                    ]
                },
                pageTypes: pageTypeService.getPageTypes(),
                sectionTypes: sectionTypeService.getSectionTypes()
            }
        },
        computed: {
            assignedTemplates(){
                if(this.model && this.model.templateAssignments){
                    return this.model.templateAssignments.map(item => item.template)
                }else{
                    return []
                }
            }
        },
        created() {
            this.fetchData(1)
        },
        methods: {
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10})
                const response = await projectService.listProjects(params)
                this.data = response.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            addRow() {
                this.model = {
                    name: null,
                    disabled: null,
                    expiredAt: null,
                    adminUser: {
                        name: null,
                        nickName: null,
                        pwd: null,
                        pwd2: null
                    },
                    datasourceAssignments: []
                }
                this.dialogFormVisible = true
            },
            editRow(row) {
                projectService.getProject(row.id).then(response => {
                    this.model = response.data
                    this.dialogFormVisible = true
                })
            },
            submitForm() {
                const validatePromises = []
                validatePromises.push(this.$refs.form.validate())
                if(this.$refs.adminUserForm){
                    validatePromises.push(this.$refs.adminUserForm.validate())
                }
                if(Array.isArray(this.$refs.datasourceForm)){
                    validatePromises.push(...this.$refs.datasourceForm.map(form => form.validate()))
                }else if(this.$refs.datasourceForm){
                    validatePromises.push(this.$refs.datasourceForm.validate())
                }
                Promise.all(validatePromises).then(() => {
                    if (this.model.id) {
                        projectService.updateProject({id: this.model.id, data: this.model}).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number + 1)
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                        }).catch(error => {
                            if(error.response && error.response.data && error.response.data.errors){
                                this.$alert(error.response.data.errors.map(item=>'<p>'+item+'</p>').join(''), '修改失败', {
                                    dangerouslyUseHTMLString: true
                                });
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: '修改失败!'
                                })
                            }
                        })
                    } else {
                        projectService.addProject(this.model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number + 1)
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                        }).catch(error => {
                            if(error.response && error.response.data && error.response.data.errors){
                                this.$alert(error.response.data.errors.map(item=>'<p>'+item+'</p>').join(''), '添加失败', {
                                    dangerouslyUseHTMLString: true
                                });
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: '添加失败!'
                                })
                            }
                        })
                    }
                }).catch(() => {
                })
            },
            deleteRow(row) {
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    projectService.deleteProject(row.id).then(() => {
                        if (this.data.content.length > 1) {
                            this.data.content.splice(this.data.content.indexOf(row), 1)
                        } else {
                            this.fetchData(this.data.number > 0 ? this.data.number : 1)
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            addDatasource(){
                const ds = {
                    datasourceConfig: null,
                    editable: null
                }
                if(this.model.datasourceAssignments){
                    this.model.datasourceAssignments.push(ds)
                }else{
                    this.model.datasourceAssignments = [ds]
                }
            },
            deleteDatasource(index){
                this.model.datasourceAssignments.splice(index, 1)
            },
            onAssignedTemplatesInput(newValue){
                if(newValue){
                    this.$set(this.model, 'templateAssignments', newValue.map(item => {return {template:item}}))
                }else{
                    this.$set(this.model, 'templateAssignments', [])
                }
            }
        }
    }
</script>
<style scoped>
</style>
